import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

interface ListProps {
  readonly icon: SVGIconComponent;
  readonly listItem: MessageKey;
}

export interface MeasureCardProps {
  readonly list: ListProps[];
  readonly subtitle: MessageKey;
  readonly title: MessageKey;
}

const MeasureCard = ({ list, subtitle, title }: MeasureCardProps) => {
  const t = useTranslations();
  return (
    <div className="text-sandstone-200">
      <div className="border-b border-sandstone-200/30 pb-4">
        <Typography color="inherit" className="text-2xl">
          {t(title)}
        </Typography>
        <Typography color="inherit">{t(subtitle)}</Typography>
      </div>
      <ul className="flex flex-col gap-4 pt-4 text-sm">
        {list.map(({ icon: Icon, listItem }) => (
          <li key={listItem} className="flex items-start gap-6">
            <Icon width={24} height={24} />
            {t(listItem)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MeasureCard;
